import { ThemeMode, UserSettings } from './types';
import { ImageriesDisplayOption } from '../../constants';

export const DEFAULT_USER_SETTINGS: UserSettings = {
  theme: ThemeMode.SYSTEM,
  createOnSearchSelection: false,
  defaultImageriesDisplay: ImageriesDisplayOption.Custom,
};
